<template>
  <div class="menu sticky">
    <p  class="menu-label"><b>Navigáció</b></p>
    <ul id="menu" class="menu-list">
      <li><a v-if="bestPractice.fields.dataSheet" class="menu-item" href="#dataSheet">Adatlap</a></li>
      <li><a v-if="bestPractice.fields.goal" class="menu-item" href="#goal">Cél</a></li>
      <li><a v-if="bestPractice.fields.introduction" class="menu-item" href="#introduction">A témakör bemutatása</a></li>
      <li><a v-if="bestPractice.fields.resultsAndExpectations" class="menu-item" href="#resultsAndExpectations">Saját eredmények</a></li>
      <li><a v-if="bestPractice.fields.expectedImpact" class="menu-item" href="#expectedImpact">Várható gazdasági hatások</a></li>
      <li><a v-if="bestPractice.fields.flowCharts" class="menu-item" href="#flowCharts">Folyamatábrák</a></li>
      <li><a v-if="bestPractice.fields.fullDescription" class="menu-item" href="#fullDescription">A jógyakorlat leírása</a></li>
      <li><a v-if="bestPractice.fields.followUp" class="menu-item" href="#followUp">Nyomonkövetés</a></li>
      <li><a v-if="bestPractice.fields.concepts" class="menu-item" href="#concepts">Fogalmak</a></li>
      <li><a v-if="bestPractice.fields.glossaryItems" class="menu-item" href="#glossaryItems">Rövidítések</a></li>
      <li><a v-if="bestPractice.fields.bibliography" class="menu-item" href="#bibliography">Irodalomjegyzék</a></li>
      <li><a v-if="bestPractice.fields.additionalInformation" class="menu-item" href="#additionalInformation">Adalékok a bevezetéshez</a></li>
      <li><a v-if="bestPractice.fields.attachments" class="menu-item" href="#attachments">Csatolmányok</a></li>
    </ul>
  </div>
</template>

<script>
  export default {
    props: [
      'bestPractice'
    ]
  }
</script>

<style scoped>
  .sticky	{
    position: sticky;
    top: 80px;
  }

  .anchor a {
    display: block;
    position: relative;
    top: -100px;
    visibility: hidden;
  }
</style>




// WEBPACK FOOTER //
// src/components/BestPractice/BestPracticeNavigation.vue